import { TOfferDataRequirement } from '../../../../types';

export function generateCopyStringBody({
  requiredDocs,
  optionalDocs,
}: {
  requiredDocs?: TOfferDataRequirement['actions'];
  optionalDocs?: TOfferDataRequirement['actions'];
}) {
  let requiredBodyText;
  if (requiredDocs) {
    requiredBodyText = generateBodyTextString({
      docRequirements: requiredDocs,
      newLineBreak: '\n',
    });
  }

  let optionalBodyText;
  if (optionalDocs) {
    optionalBodyText = generateBodyTextString({
      docRequirements: optionalDocs,
      newLineBreak: '\n',
    });
  }

  return `${requiredBodyText}${optionalBodyText}`;
}

export function generateBodyTextString({
  docRequirements,
  newLineBreak,
}: {
  docRequirements: TOfferDataRequirement['actions'];
  newLineBreak: string;
}) {
  const text = docRequirements.map((requirement) => {
    const title = requirementsTitle(
      requirement.type,
      requirement.quantifier?.value,
    );

    if (!title) return '';

    return `- ${title} ${
      requirement.is_optional ? '(optional)' : ''
    }${newLineBreak}`;
  });

  return text.join('');
}

export const requirementsTitle = function (
  type: string,
  quantifier: number | undefined,
) {
  switch (type) {
    case 'company_accounts':
      return 'Most recent filed company accounts';
    case 'bank_statement':
      if (quantifier) {
        return `Last ${quantifier} months of bank statements as PDF files`;
      }
      return 'Last bank statements as PDF files';
    case 'vat_return': {
      const quarter = quantifier && quantifier / 3;
      if (quarter && quarter > 1) {
        return `Last ${quarter} quarterly VAT returns`;
      }
      return `Last quarter's VAT return`;
    }
    case 'link_open_banking':
      return 'Link your trading bank account';
    case 'via_open_banking':
      return 'Link your business bank account';
    case 'personal_bank_statement':
      return 'Last 3 months personal bank statements';
    case 'management_accounts':
      return 'Current management accounts';
    case 'business_plan':
      return 'Business plan';
    case 'aged_debtor_report':
      return 'Aged debtor report';
    default:
      break;
  }
};

export const requirementsSubTitle = function (type: string) {
  switch (type) {
    case 'company_accounts':
      return 'These should include balance sheets and profit and loss';
    case 'bank_statement':
      return 'You can download these from your online banking';
    case 'vat_return':
      return 'You can download these from HMRC';
    case 'management_accounts':
      return 'These should include balance sheets and profit and loss';
    case 'aged_debtor_report':
      return 'This should include lists of all unpaid sales invoices, and show how much money you’re owed overall at a given date.';
    default:
      return '';
  }
};
